export default __webpack_public_path__ + "static/media/news1.a9fc65d8.mp4";